import React, { Component } from "react"

export default class NavigateToShareProfile extends Component {
  componentDidMount = () => {
    const fileurl = window.location.search.substring(1).split("fileurl=")[1]
    const newURL = fileurl.replace("https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile",
                                  "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3") 
    const path = {
        pathname: "/FileViewer",
        // fileurl: `https://platform-backend-files.s3-ap-southeast-2.amazonaws.com/${fileurl}`,
        fileurl: newURL,
    }
    this.props.history.push(path)
  }

  render = () => <div />
}
